import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioArchIo } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_ARCH_IO: TIdToPageConfigMap = {
  [PageIdStylioArchIo.AGE_ARCH_IO]: {
    id: PageIdStylioArchIo.AGE_ARCH_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioArchIo.SHOP_SMARTER_ARCH_IO]: {
    id: PageIdStylioArchIo.SHOP_SMARTER_ARCH_IO,
    headerId: HeaderId.BACK_TITLE_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdStylioArchIo.HAIR_COLOR_ARCH_IO]: {
    id: PageIdStylioArchIo.HAIR_COLOR_ARCH_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.WARDROBE_COLORS_ARCH_IO]: {
    id: PageIdStylioArchIo.WARDROBE_COLORS_ARCH_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.COLOR_CONFIDENCE_ARCH_IO]: {
    id: PageIdStylioArchIo.COLOR_CONFIDENCE_ARCH_IO,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.EYES_COLOR_ARCH_IO]: {
    id: PageIdStylioArchIo.EYES_COLOR_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.SKIN_COLOR_ARCH_IO]: {
    id: PageIdStylioArchIo.SKIN_COLOR_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.CLIMAT_ARCH_IO]: {
    id: PageIdStylioArchIo.CLIMAT_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.BODY_SHAPE_ARCH_IO]: {
    id: PageIdStylioArchIo.BODY_SHAPE_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.BODY_SHAPE_CONFIDENCE_ARCH_IO]: {
    id: PageIdStylioArchIo.BODY_SHAPE_CONFIDENCE_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.SHOW_OFF_FEATURES_ARCH_IO]: {
    id: PageIdStylioArchIo.SHOW_OFF_FEATURES_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.STYLIO_TO_HELP_ARCH_IO]: {
    id: PageIdStylioArchIo.STYLIO_TO_HELP_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.MAIN_GOAL_ARCH_IO]: {
    id: PageIdStylioArchIo.MAIN_GOAL_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioArchIo.WHERE_TO_SHOP_ARCH_IO]: {
    id: PageIdStylioArchIo.WHERE_TO_SHOP_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.WARDROBE_PERCENTAGE_ARCH_IO]: {
    id: PageIdStylioArchIo.WARDROBE_PERCENTAGE_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.URGE_1_ARCH_IO]: {
    id: PageIdStylioArchIo.URGE_1_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArchIo.URGE_2_ARCH_IO]: {
    id: PageIdStylioArchIo.URGE_2_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArchIo.URGE_3_ARCH_IO]: {
    id: PageIdStylioArchIo.URGE_3_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArchIo.URGE_9_ARCH_IO]: {
    id: PageIdStylioArchIo.URGE_9_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArchIo.URGE_4_ARCH_IO]: {
    id: PageIdStylioArchIo.URGE_4_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArchIo.URGE_5_ARCH_IO]: {
    id: PageIdStylioArchIo.URGE_5_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArchIo.URGE_6_ARCH_IO]: {
    id: PageIdStylioArchIo.URGE_6_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArchIo.STYLE_PROFILE_ARCH_IO]: {
    id: PageIdStylioArchIo.STYLE_PROFILE_ARCH_IO,
  },
  [PageIdStylioArchIo.WARDROBE_READY_ARCH_IO]: {
    id: PageIdStylioArchIo.WARDROBE_READY_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.URGE_7_ARCH_IO]: {
    id: PageIdStylioArchIo.URGE_7_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArchIo.URGE_8_ARCH_IO]: {
    id: PageIdStylioArchIo.URGE_8_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArchIo.STYLE_DRAWN_TO_ARCH_IO]: {
    id: PageIdStylioArchIo.STYLE_DRAWN_TO_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.OUTFIT_EMOTION_ARCH_IO]: {
    id: PageIdStylioArchIo.OUTFIT_EMOTION_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.STYLE_DISCOVERY_ARCH_IO]: {
    id: PageIdStylioArchIo.STYLE_DISCOVERY_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.NOTHING_TO_WEAR_ARCH_IO]: {
    id: PageIdStylioArchIo.NOTHING_TO_WEAR_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.ARCHETYPE_INTRO_ARCH_IO]: {
    id: PageIdStylioArchIo.ARCHETYPE_INTRO_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArchIo.DRESSED_FEEL_ARCH_IO]: {
    id: PageIdStylioArchIo.DRESSED_FEEL_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.STYLE_MATTERS_MOST_ARCH_IO]: {
    id: PageIdStylioArchIo.STYLE_MATTERS_MOST_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.OUTFIT_VIBE_ARCH_IO]: {
    id: PageIdStylioArchIo.OUTFIT_VIBE_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.OUTFIT_COMPLIMENT_ARCH_IO]: {
    id: PageIdStylioArchIo.OUTFIT_COMPLIMENT_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.SHOP_PULLS_FIRST_ARCH_IO]: {
    id: PageIdStylioArchIo.SHOP_PULLS_FIRST_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.ARCHETYPE_LOADING_ARCH_IO]: {
    id: PageIdStylioArchIo.ARCHETYPE_LOADING_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArchIo.ARCHETYPE_RESULT_ARCH_IO]: {
    id: PageIdStylioArchIo.ARCHETYPE_RESULT_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArchIo.LOOKING_FEMININE_ARCH_IO]: {
    id: PageIdStylioArchIo.LOOKING_FEMININE_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.STYLES_FEEL_LIKE_YOU_ARCH_IO]: {
    id: PageIdStylioArchIo.STYLES_FEEL_LIKE_YOU_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.TALL_ARCH_IO]: {
    id: PageIdStylioArchIo.TALL_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.WEIGHT_ARCH_IO]: {
    id: PageIdStylioArchIo.WEIGHT_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.WARDROBE_CHANGED_ARCH_IO]: {
    id: PageIdStylioArchIo.WARDROBE_CHANGED_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.FAVORITE_COLORS_ARCH_IO]: {
    id: PageIdStylioArchIo.FAVORITE_COLORS_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.LIKE_OR_DISLIKE_11_ARCH_IO]: {
    id: PageIdStylioArchIo.LIKE_OR_DISLIKE_11_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.LIKE_OR_DISLIKE_14_ARCH_IO]: {
    id: PageIdStylioArchIo.LIKE_OR_DISLIKE_14_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.LIKE_OR_DISLIKE_15_ARCH_IO]: {
    id: PageIdStylioArchIo.LIKE_OR_DISLIKE_15_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.LIKE_OR_DISLIKE_18_ARCH_IO]: {
    id: PageIdStylioArchIo.LIKE_OR_DISLIKE_18_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.LIKE_OR_DISLIKE_19_ARCH_IO]: {
    id: PageIdStylioArchIo.LIKE_OR_DISLIKE_19_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.WALK_INTO_ROOM_ARCH_IO]: {
    id: PageIdStylioArchIo.WALK_INTO_ROOM_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.PERFECT_WEEKEND_ARCH_IO]: {
    id: PageIdStylioArchIo.PERFECT_WEEKEND_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.WARDROBE_FEEL_ARCH_IO]: {
    id: PageIdStylioArchIo.WARDROBE_FEEL_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.SHOPPING_ARCH_IO]: {
    id: PageIdStylioArchIo.SHOPPING_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.SHOPPING_BUDGET_ARCH_IO]: {
    id: PageIdStylioArchIo.SHOPPING_BUDGET_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.SHOPPING_PRIORITY_ARCH_IO]: {
    id: PageIdStylioArchIo.SHOPPING_PRIORITY_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.CURATED_LINKS_ARCH_IO]: {
    id: PageIdStylioArchIo.CURATED_LINKS_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.LIFESTYLE_FOCUS_ARCH_IO]: {
    id: PageIdStylioArchIo.LIFESTYLE_FOCUS_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.OUTFIT_NEEDS_ARCH_IO]: {
    id: PageIdStylioArchIo.OUTFIT_NEEDS_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.WARDROBE_ALIGNS_ARCH_IO]: {
    id: PageIdStylioArchIo.WARDROBE_ALIGNS_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.LIFESTYLE_CHANGES_ARCH_IO]: {
    id: PageIdStylioArchIo.LIFESTYLE_CHANGES_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.AMAZON_FRUSTRATION_ARCH_IO]: {
    id: PageIdStylioArchIo.AMAZON_FRUSTRATION_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioArchIo.PREPARE_FLOW_ARCH_IO]: {
    id: PageIdStylioArchIo.PREPARE_FLOW_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArchIo.EMAIL_ARCH_IO]: {
    id: PageIdStylioArchIo.EMAIL_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArchIo.EMAIL_CONSENT_ARCH_IO]: {
    id: PageIdStylioArchIo.EMAIL_CONSENT_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArchIo.NAME_ARCH_IO]: {
    id: PageIdStylioArchIo.NAME_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArchIo.READINESS_LEVEL_ARCH_IO]: {
    id: PageIdStylioArchIo.READINESS_LEVEL_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArchIo.PRE_PAYWALL_OFFER_ARCH_IO]: {
    id: PageIdStylioArchIo.PRE_PAYWALL_OFFER_ARCH_IO,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioArchIo.SUBSCRIPTIONS_ARCH_IO]: {
    id: PageIdStylioArchIo.SUBSCRIPTIONS_ARCH_IO,
  },
  [PageIdStylioArchIo.CANCEL_OFFER_ARCH_IO]: {
    id: PageIdStylioArchIo.CANCEL_OFFER_ARCH_IO,
  },
  [PageIdStylioArchIo.AI_STYLIST_UPSELL_ARCH_IO]: {
    id: PageIdStylioArchIo.AI_STYLIST_UPSELL_ARCH_IO,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioArchIo.SUB_UPSELL_ARCH_IO]: {
    id: PageIdStylioArchIo.SUB_UPSELL_ARCH_IO,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioArchIo.UPSELL_ARCH_IO]: {
    id: PageIdStylioArchIo.UPSELL_ARCH_IO,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioArchIo.DOWNLOAD_ARCH_IO]: {
    id: PageIdStylioArchIo.DOWNLOAD_ARCH_IO,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
